var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',{attrs:{"value":_vm.visible}},[_c('v-progress-circular',{attrs:{"size":"64","color":"#C4170C","indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }